import { ListItem, makeStyles } from '@rneui/themed'
import React from 'react'

interface Props {
  checked?: boolean
  checkedColor?: string | undefined
  uncheckedColor?: string | undefined
  checkedIcon?: string
  uncheckedIcon?: string
  onPress?: () => void
  disabled?: boolean
}

export function CheckBox({
  checked,
  onPress,
  checkedColor,
  uncheckedColor,
  checkedIcon,
  uncheckedIcon,
  disabled,
}: Props) {
  const styles = useStyles({ disabled })

  return (
    <ListItem.CheckBox
      checked={checked ?? false}
      disabled={disabled}
      checkedColor={checkedColor ?? styles.checkboxChecked.color}
      uncheckedColor={uncheckedColor ?? styles.checkboxUnchecked.color}
      checkedIcon={checkedIcon ?? 'check-circle'}
      uncheckedIcon={uncheckedIcon ?? 'circle-o'}
      onPress={onPress}
      containerStyle={styles.checkboxContainer}
    />
  )
}

const useStyles = makeStyles((theme, { disabled }: { disabled?: boolean }) => ({
  checkboxChecked: disabled
    ? {
        color: theme.colors?.grey4,
      }
    : {
        color: theme.colors?.primary,
      },
  checkboxUnchecked: disabled
    ? {
        color: theme.colors?.grey5,
      }
    : {
        color: theme.colors?.primary,
      },
  checkboxContainer: { backgroundColor: 'transparent' },
}))
